import React, { useState } from "react";
import "../ContactUs/ContactUs.css";
import { FaLinkedin, FaInstagram, FaFacebook, FaTwitter } from "react-icons/fa";
import { MdEmail, MdPhone } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
// import axios from "axios";

function ContactUs() {
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const [first_nameError, setFirstNameError] = useState("");
  const [last_nameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [messageError, setMessageError] = useState("");

  const EmailReg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

  const handleSubmit = (e) => {
    if (onContact()) {
      alert("we will connect soon..");
      console.log(first_name);
      console.log(last_name);
      console.log(email);
      console.log(phone);
      console.log(message);
      // var Base_URL = " ";
      // var Data = {
      //   first_name: first_name,
      //   last_name: last_name,
      //   email: email,
      //   phone: phone,
      //   message: message,
      // };
      // var headerConfig = {
      //   headers: {
      //     accept: "application/json",
      //   },
      // };
      // axios
      //   .post(Base_URL + "/contact", Data, headerConfig)
      //   .then((response) => {
      //     if (response.status === 200) {
      //       console.log(first_name);
      //       console.log(last_name);
      //       console.log(email);
      //       console.log(phone);
      //       console.log(message);
      //     }
      //   })
      //   .catch(function (err) {
      //     alert("something wrong try again later");
      //     console.log(err.response.data.error.message);
      //   });
    }
  };
  const onContact = () => {
    let isValid = true;
    if (first_name === "") {
      isValid = false;
      setFirstNameError("First Name is empty");
      // alert("First Name is empty");
    }
    if (last_name === "") {
      isValid = false;
      setLastNameError("Last Name is empty");
    }
    if (!EmailReg.test(email)) {
      isValid = false;
      setEmailError("Please enter valid email");
      if (email === "") {
        isValid = false;
        setEmailError("Email is empty");
      }
    }
    if (phone === "") {
      isValid = false;
      setPhoneError("Phone is empty");
    }
    if (message === "") {
      isValid = false;
      setMessageError("Message is empty");
    }
    return isValid;
  };

  return (
    <>
      <div className="contact-us">
        <p className="contact-us-title">Contact Us</p>
        <div className="main">
          <div className="contact-left-side">
            <div className="text">
              <h2>Contact Information</h2>
              <p>Say something to start a chat!</p>
            </div>
            <div className="contact-details">
              <div className="contact">
                {/* <IoLocationSharp /> */}
                <h3 style={{ textDecoration: "underline" }}>
                  Medisol Lifescience Pvt. Ltd.
                </h3>
              </div>
              <div className="contact">
                <IoLocationSharp />
                <p>
                  1417, Maker Chamber 5, Nariman Point, Mumbai 400021
                </p>
              </div>
              <div className="contact">
                <MdPhone />
                <p>91-22-69074440</p>
              </div>
              <div className="contact">
                <MdEmail />
                <p>medisol@asianitg.com</p>
              </div>
            </div>
            <div className="social-icons">
              <div className="icon twitter">
                {" "}
                <FaTwitter />{" "}
              </div>
              <div className="icon linkedin">
                {" "}
                <FaLinkedin />{" "}
              </div>
              <div className="icon instagram">
                {" "}
                <FaInstagram />{" "}
              </div>
              <div className="icon facebook">
                {" "}
                <FaFacebook />{" "}
              </div>
            </div>{" "}
          </div>
          <div className="contact-right-side">
            <div className="details">
              <div className="contact-right-side-text">
                <h2>Contact Information</h2>
                <p>Say something to start a chat!</p>
              </div>
              <div className="row">
                <div className="detail">
                  <p>First Name</p>
                  <input
                    type="text"
                    value={first_name}
                    onChange={(e) => [
                      setFirstName(e.target.value),
                      setFirstNameError("")]
                    }
                    placeholder="Enter first name"
                    required
                    className="contact-right-side-input"
                  />
                  <br />
                  <span className="contact_error">{first_nameError}</span>
                </div>
                <div className="detail">
                  <p>Last Name</p>
                  <input
                    type="text"
                    value={last_name}
                    onChange={(e) =>
                      [setLastName(e.target.value),
                      setLastNameError("")
                      ]}
                    placeholder="Enter last name"
                    required
                    className="contact-right-side-input"
                  /><br />
                  <span className="contact_error">{last_nameError}</span>
                </div>
              </div>
              <div className="row">
                <div className="detail">
                  <p>Email</p>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => [setEmail(e.target.value),
                    setEmailError("")
                    ]}
                    placeholder="Enter Email"
                    required
                    className="contact-right-side-input"
                  /><br />
                  <span className="contact_error">{emailError}</span>
                </div>

                <div className="detail">
                  <p>Phone</p>
                  <input
                    type="text"
                    value={phone}
                    onChange={(e) => [
                      setPhone(e.target.value),
                      setPhoneError("")
                    ]}
                    placeholder="Enter Phone Number"
                    required
                    className="contact-right-side-input"
                  /><br />
                  <span className="contact_error">{phoneError}</span>
                </div>
              </div>

              <div className="detail">
                <p>Message</p>
                <textarea
                  type="text"
                  value={message}
                  onChange={(e) => [
                    setMessage(e.target.value),
                    setMessageError("")
                  ]}
                  placeholder="Enter Message"
                  className="message"
                  required
                />
              </div>
              <span className="contact_error">{messageError}</span>

              <div className="bottom-container">
                {" "}
                <Link
                  to="/contact"
                  className="btn-send-message"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Send Message{" "}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ContactUs;
